export const SET_DISPACTHER_NOTES_LIST_DATA = "SET_DISPACTHER_NOTES_LIST_DATA";
export const RESET_ZONE_REDUCER = "RESET_ZONE_REDUCER";
